import React, { Component } from 'react';
import { connect } from 'react-redux';
import { WithStyles } from 'decorators/withStyles';
import { loadTopicInformations, errorComponents } from 'actionCreators/forum';
import LessonComments from './LessonComments';
import { getUrlParams } from 'utils';
import { requestCustomization } from 'actionCreators/customization';
import Loader from './Loader';
import ServerError from 'components/Shared/Error/ServerError';
import { WithRouter } from 'decorators/withRouter';

interface IComent {
  ownerId: number;
  coment: string;
  ownerName: string;
}

interface ITopics {
  title: string;
  coments: IComent[];
}

interface IState {
  topics?: ITopics[];
  open?: boolean;
}

interface IProps {
  requestCustomization: typeof requestCustomization;
  topics?: ITopics[];
  classes?: any;
  selectedTopic?: ITopics;
  loadTopicInformations: typeof loadTopicInformations;
  err: any;
  match?: any;
}

@WithStyles({
  container: {
    display: 'flex',
    justifyContent: 'center',
    overflow: 'auto',
    backgroundColor: '#FFF',
    minHeight: 'calc(100vh - 60px)',
    '&::-webkit-scrollbar': {
      width: '6px',
      backgroundColor: '#F5F5F5',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#555',
      borderRadius: 10,
    },
  },
  err: {
    height: '-webkit-fill-available',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 30,
    fontWight: 300,
  },
})
@WithRouter()
class Forum extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { open: false };
  }

  componentDidMount() {
    let params = getUrlParams();
    params = { ...params, id: this.props.match.params.topicID };
    this.props.requestCustomization(this.props.match.params.courseHash);
    this.props.loadTopicInformations(params);
  }

  render() {
    if (!this.state) return null;

    const { classes, selectedTopic, err } = this.props;
    if (err.hasError) {
      if (errorComponents.has(err.statusError)) {
        const Error = errorComponents.get(err.statusError);
        return <Error />;
      }
      return <ServerError />;
    }
    if (!selectedTopic) return null;

    return (
      <div style={{ height: '-webkit-fill-available' }}>
        <Loader />

        <div className={classes.container}>
          <LessonComments />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: any, ownProps: any) => {
  return {
    ...ownProps,
    selectedTopic: state.forum.selectedTopic,
    err: state.forum.err,
  };
};

export default connect(mapStateToProps, { loadTopicInformations, requestCustomization })(Forum);
